export default {
	title: "Ссылка отправлена",
	description: "На указанный вами адрес эл. почты отправлена ссылка на восстановление пароля",
	backButtonText: "Вернуться назад",
}
